<div class="d-flex justify-content-end gap-1 align-items-center flex-wrap">
    <button type="button" class="btn btn-link" (click)="changePage(page - 1)" [disabled]="page === 1">
        <i class="bi bi-chevron-left"></i>
    </button>
    <button
        type="button"
        class="btn btn-link"
        *ngFor="let p of pages"
        (click)="changePage(p)"
        [class.active]="page === p"
        [disabled]="page === p"
    >
        {{ p }}
    </button>
    <button type="button" class="btn btn-link" (click)="changePage(page + 1)" [disabled]="page === pages.length">
        <i class="bi bi-chevron-right"></i>
    </button>
</div>
